import { sortBy } from 'lodash';
import React, { useState } from 'react';

import { Link } from '@dndbeyond/character-common-components/es';
import { Select } from '@dndbeyond/character-components/es';
import {
    ApiAdapterPromise,
    ApiAdapterRequestConfig,
    ApiResponse,
    HtmlSelectOption,
    Race,
    RaceDefinitionContract,
    RuleData,
    RuleDataUtils,
} from '@dndbeyond/character-rules-engine/es';

import RaceFilterListing from '../../../Shared/components/RaceFilterListing';

const HOMEBREW_ID = 'HOMEBREW';

interface Props {
    loadRaces: (
        additionalConfig?: Partial<ApiAdapterRequestConfig>,
    ) => ApiAdapterPromise<ApiResponse<Array<RaceDefinitionContract>>>;
    onRaceSelected: (race: RaceDefinitionContract) => void;
    currentRace?: Race | null;
    ruleData: RuleData;
}
export const RaceChooser: React.FC<Props> = ({ loadRaces, onRaceSelected, currentRace = null, ruleData }) => {
    const [source, setSource] = useState<string | null>(null);
    const [sourceOptions, setSourceOptions] = useState<Array<HtmlSelectOption>>([]);

    const handleRacesLoad = (races: Array<RaceDefinitionContract>) => {
        const itemSourceIds = races.reduce((acc: Array<number>, race) => {
            const { sources } = race;
            if (sources) {
                sources.forEach((sourceMapping) => {
                    if (!acc.includes(sourceMapping.sourceId)) {
                        acc.push(sourceMapping.sourceId);
                    }
                });
            }

            return acc;
        }, []);

        const sourceOptions = RuleDataUtils.getSources(ruleData)
            .filter((source) => itemSourceIds.includes(source.id))
            .map((source) => ({
                value: '' + source.id,
                label: source.description,
            }));
        const sortedSourceOptions = sortBy(sourceOptions, ['label']);

        let raceFilterOptions: Array<HtmlSelectOption> = [];
        if (races.find((race) => race.isHomebrew)) {
            raceFilterOptions.push({
                label: 'Homebrew',
                value: HOMEBREW_ID,
            });
        }

        if (sortedSourceOptions.length) {
            raceFilterOptions.push(...sortedSourceOptions);
        }

        setSourceOptions(raceFilterOptions);
    };

    return (
        <div className="race-chooser">
            {sourceOptions.length > 0 && (
                <div className="race-chooser-source">
                    <div className="builder-field-heading">Filter Race Source(s)</div>
                    <div className="builder-field-input">
                        <Select
                            options={sourceOptions}
                            onChange={(value) => setSource(value)}
                            value={source}
                            placeholder={'-- All Sources --'}
                        />
                    </div>
                </div>
            )}
            <div className="ct-character-tools__marketplace-callout">
                Looking for something not in the list below? Unlock all official options in the{' '}
                <Link url="/marketplace">Marketplace</Link>.
            </div>
            <RaceFilterListing
                loadRaces={loadRaces}
                onLoadRaces={handleRacesLoad}
                currentRace={currentRace}
                currentSourceFilter={source}
                onRaceSelected={onRaceSelected}
                ruleData={ruleData}
            />
        </div>
    );
};

export default RaceChooser;
